/* Banana Research lens review page behaviour. Hand kept.
   One feature: the specimen gallery opens in a lightbox, with left/right
   arrows and keyboard navigation cycling the specimen's views. */
(function () {
  "use strict";
  var figs = Array.prototype.slice.call(
    document.querySelectorAll('.lrev .gallery .grid figure'));
  if (!figs.length) return;

  var items = figs.map(function (f) {
    var img = f.querySelector('img');
    var cap = f.querySelector('figcaption');
    return { src: img.currentSrc || img.src, alt: img.alt,
             cap: cap ? cap.textContent : '' };
  });

  var idx = 0, overlay = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'lrev-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button class="lb-close" type="button" aria-label="Close">&times;</button>' +
      '<button class="lb-prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<figure><img alt=""><figcaption></figcaption></figure>' +
      '<button class="lb-next" type="button" aria-label="Next">&#8250;</button>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.lb-close').onclick = close;
    overlay.querySelector('.lb-prev').onclick = function () { show(idx - 1); };
    overlay.querySelector('.lb-next').onclick = function () { show(idx + 1); };
  }

  function show(i) {
    idx = (i + items.length) % items.length;
    var img = overlay.querySelector('img');
    img.src = items[idx].src; img.alt = items[idx].alt;
    overlay.querySelector('figcaption').textContent = items[idx].cap;
  }

  function onkey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  }

  function open(i) {
    if (!overlay) build();
    show(i);
    overlay.classList.add('on');
    document.addEventListener('keydown', onkey);
    document.body.style.overflow = 'hidden';
    overlay.querySelector('.lb-close').focus();
  }

  function close() {
    overlay.classList.remove('on');
    document.removeEventListener('keydown', onkey);
    document.body.style.overflow = '';
  }

  figs.forEach(function (f, i) {
    f.classList.add('lb-openable');
    f.setAttribute('role', 'button');
    f.setAttribute('tabindex', '0');
    f.setAttribute('aria-label', items[i].alt);
    f.addEventListener('click', function () { open(i); });
    f.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); }
    });
  });
})();
